<template>
  <div style="min-height: 200px">
<!--    {{descContent}}-->
    <p v-for="item in descContent" style="line-height: 1.5; margin-bottom: 16px">{{item}}</p>
  </div>
</template>

<script>
export default {
  name: "showDesc",
  props: {
    value: Object
  },
  data() {
    return {
      pageDesc: this.value.pageDesc,
    }
  },
  computed: {
    descContent() {
      let content =  this.pageDesc.split('\n')
      return content
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
